import { FormStepType } from "@/data/forms/types";
import { UseFormWatch } from "react-hook-form";

const extractConditions = (obj: FormStepType | null): string[] => {
  const conditions = new Set<string>();

  obj?.groups.forEach((group) => {
    if (group.condition) {
      conditions.add(group.condition.field);
    }

    group.subGroups?.forEach((subGroup) => {
      if (subGroup.condition) {
        conditions.add(subGroup.condition.field);
      }
    });

    group.fields?.forEach((field) => {
      if (field.condition) {
        conditions.add(field.condition.field);
      }
    });
  });

  return Array.from(conditions);
};

const useDependableFields = (formStep: FormStepType | null, watch: UseFormWatch<any>) => {
  const dependableFieldsToArray = (dependableFields: string[]) => {
    return dependableFields.reduce(
      (acc, field) => {
        acc[field] = watch(field);
        return acc;
      },
      {} as { [key: string]: any }
    );
  };

  const fieldsToWatch = dependableFieldsToArray(extractConditions(formStep));
  return fieldsToWatch;
};

export default useDependableFields;
